const materialIconNames = [
    "description",
    "home",
    "folder",
    "folder_open",
    "insert_drive_file",
    "list",
    "view_list",
    "view_module",
    "dashboard",
    "assessment",
    "pie_chart",
    "show_chart",
    "trending_up",
    "trending_down",
    "timeline",
    "store",
    "shopping_cart",
    "local_offer",
    "label",
    "star",
    "star_border",
    "favorite",
    "favorite_border",
    "book",
    "bookmark",
    "bookmark_border",
    "school",
    "person",
    "people",
    "work",
    "settings",
    "settings_applications",
    "build",
    "tune",
    "security",
    "lock",
    "lock_open",
    "vpn_key",
    "mail",
    "email",
    "contact_mail",
    "phone",
    "call",
    "chat",
    "forum",
    "help",
    "help_outline",
    "info",
    "info_outline",
    "warning",
    "report",
    "check_circle",
    "check",
    "close",
    "cancel",
    "add",
    "remove",
    "edit",
    "delete",
    "share",
    "link",
    "attach_file",
    "cloud",
    "cloud_upload",
    "cloud_download",
    "image",
    "photo",
    "photo_camera",
    "collections",
    "palette",
    "brush",
    "color_lens",
    "style",
    "flag",
    "public",
    "place",
    "map",
    "location_on",
    "navigation",
    "menu",
    "widgets",
    "apps",
    "extension",
    "format_list_bulleted",
    "format_list_numbered",
    "assignment",
    "assignment_turned_in",
    "assignment_late",
    "receipt",
    "credit_card",
    "account_balance",
    "account_balance_wallet",
    "event",
    "event_note",
    "event_available",
    "event_busy",
    "schedule",
    "today",
    "alarm",
    "notifications",
    "notifications_active",
    "notifications_none",
    "visibility",
    "visibility_off",
    "search",
    "filter_list",
    "sort",
    "swap_vert",
    "swap_horiz",
    "zoom_in",
    "zoom_out",
    "play_arrow",
    "pause",
    "stop",
    "volume_up",
    "volume_off",
    "music_note",
    "video_library",
    "movie",
    "tv",
    "language",
    "translate",
    "healing",
    "local_hospital",
    "spa",
    "pets",
    "child_friendly",
];

export default materialIconNames;
